import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    app_name: "AgriNova",
    slogan: "Nourrir · Grandir · Innover",
    login: "Connexion",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    sign_in: "Se connecter",
    dashboard: "Tableau de bord",
    parcelles: "Parcelles",
    pisciculture: "Pisciculture",
    suppliers: "Fournisseurs & Stocks",
    clients: "Clients & Commandes",
    payments: "Paiements",
    hectares: "Hectares totaux",
    ongoing_crops: "Cultures en cours",
    pending_orders: "Commandes en attente",
    quarter_revenue: "CA du trimestre",
    low_stock: "Stocks bas",
    upcoming_harvests: "Prochaines récoltes",
    recent_orders: "Commandes récentes",
    recent_payments: "Paiements récents",
    revenue_by_method: "Revenus par mode",
    add: "Ajouter",
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    name: "Nom",
    category: "Catégorie",
    site: "Site",
    area: "Surface (ha)",
    culture: "Culture",
    status: "Statut",
    actions: "Actions",
    map_view: "Vue carte",
    grid_view: "Vue grille",
    list_view: "Liste",
    all_sites: "Tous les sites",
    ponds: "Bassins",
    species: "Espèce",
    capacity: "Capacité (m³)",
    stocked_date: "Date de mise en eau",
    current_stock: "Stock actuel",
    quantity: "Quantité",
    unit: "Unité",
    threshold: "Seuil mini",
    unit_cost: "Coût unitaire",
    supplier: "Fournisseur",
    phone: "Téléphone",
    city: "Ville",
    customer: "Client",
    type: "Type",
    product: "Produit",
    price: "Prix",
    total: "Total",
    destination: "Destination",
    order_date: "Date commande",
    method: "Mode",
    amount: "Montant",
    reference: "Référence",
    date: "Date",
    orange_money: "Orange Money",
    mtn_mobile_money: "MTN Mobile Money",
    virement: "Virement bancaire",
    cash: "Espèces",
    welcome: "Bienvenue",
    days: "jours",
    no_data: "Aucune donnée",
    confirm_delete: "Confirmer la suppression ?",
    added: "Ajouté",
    updated: "Mis à jour",
    deleted: "Supprimé",
    error: "Erreur",
    farm_sites: "Sites d'exploitation",
    seeded_date: "Date de semis",
    expected_harvest: "Récolte prévue",
    plantings: "Semis",
    harvests: "Récoltes",
    new_planting: "Nouveau semis",
    new_harvest: "Nouvelle récolte",
    stock_items: "Intrants",
    orders: "Commandes",
    deliveries: "Livraisons",
    manage: "Gérer",
    parcelle: "Parcelle",
    scientific_name: "Nom scientifique",
    cycle_days: "Cycle (jours)",
    en_attente: "En attente",
    livrée: "Livrée",
    role_admin: "Administrateur",
    key_indicators: "Indicateurs clés",
    active_ponds: "Bassins actifs",
    total_customers: "Clients enregistrés",
    total_suppliers: "Fournisseurs",
    harvest_timeline: "Calendrier des récoltes",
    drag_hint: "Glissez-déposez une récolte vers un autre mois pour la replanifier",
    drop_here: "Déposer ici",
    notifications: "Notifications",
    mark_all_read: "Tout lire",
    pdf_report: "Rapport PDF trimestriel",
    quarter: "Trimestre",
    year: "Année",
    download: "Télécharger",
    hero_title: "De la terre et de l'eau à la table, pilotez votre croissance.",
    hero_sub: "Cultures, pisciculture, fournisseurs, stocks, clients & paiements Mobile Money — votre exploitation, simplifiée.",
    dark_mode: "Mode sombre",
    light_mode: "Mode clair",
    install_app: "Installer AgriNova",
    install_hint: "Accès rapide depuis votre écran d'accueil, même hors connexion",
    install: "Installer",
    users: "Utilisateurs",
    role: "Rôle",
    add_user: "Nouvel utilisateur",
    role_admin: "Administrateur",
    role_gerant: "Gérant",
    role_comptable: "Comptable",
    role_ouvrier: "Ouvrier",
    role_desc_admin: "Accès complet, gestion des utilisateurs",
    role_desc_gerant: "Gestion quotidienne, sans utilisateurs",
    role_desc_comptable: "Consultation + commandes & paiements",
    role_desc_ouvrier: "Terrain : relevés bassins & récoltes",
    pond_journal: "Journal",
    add_log: "Nouveau relevé",
    weight_g: "Poids moyen (g)",
    feed_kg: "Aliment (kg)",
    mortality: "Mortalité",
    water_temp: "Temp. eau (°C)",
    latest_weight: "Poids actuel",
    total_feed: "Aliment total",
    purchases: "Achats",
    total_spent: "Total dépensé",
    agri_kpis: "Agriculture",
    pisci_kpis: "Pisciculture",
    business_kpis: "Business",
    alerts_title: "Alertes",
    active_plots: "Parcelles actives",
    cultures_maturing: "Maturité ≤ 30 j",
    production_harvested: "Prod. récoltée",
    fish_alive: "Poissons en élevage",
    biomass_kg: "Biomasse estimée",
    avg_fcr: "FCR moyen",
    feed_30d: "Aliment 30 j",
    mortality_30d: "Mortalité 30 j",
    orders_total: "Commandes",
    sales_today: "Ventes du jour",
    receivables: "Créances clients",
    out_of_stock: "Ruptures",
    oxygen: "Oxygène (mg/L)",
    commandée: "Commandée",
    confirmée: "Confirmée",
    préparée: "Préparée",
    expédiée: "Expédiée",
    en_livraison: "En livraison",
    annulée: "Annulée",
    marketplace: "Marketplace",
    order_now: "Passer commande",
    portal_sub: "Commandez directement nos productions — suivi en temps réel",
    your_order: "Votre commande",
    order_success: "Commande enregistrée !",
    keep_ref: "Conservez votre référence de suivi :",
    track_order: "Suivre ma commande",
    track: "Suivre",
    tasks: "Travaux agricoles",
    assignee: "Responsable",
    equipment: "Matériel",
    cost: "Coût",
    planifiée: "Planifiée",
    en_cours: "En cours",
    terminée: "Terminée",
    task_labour: "Labour",
    task_préparation_sol: "Préparation du sol",
    task_semis: "Semis",
    task_désherbage: "Désherbage",
    task_fertilisation: "Fertilisation",
    task_traitement: "Traitement",
    task_irrigation: "Irrigation",
    task_récolte: "Récolte",
    task_entretien: "Entretien",
    rentability: "Rentabilité",
    expected_cost: "Coût prévu",
    actual_cost: "Coût réel",
    cost_gap: "Écart coût",
    expected_yield: "Rendement prévu (t)",
    actual_yield: "Rendement réel (t)",
    yield_gap: "Écart rendement",
    feed_cost: "Coût aliment",
    production: "Production",
    revenue: "CA",
    margin: "Marge",
    en_cours_label: "En cours",
    récoltée: "Récoltée",
    health: "Santé & Biosécurité",
    biosecurity: "Prévention & traitements",
    agriculture: "Agriculture",
    health_maladie: "Maladie",
    health_ravageur: "Ravageur",
    health_traitement: "Traitement",
    health_incident: "Incident",
    health_quarantaine: "Quarantaine",
    target: "Cible",
    issue: "Description",
    product_used: "Produit / Action",
    dosage: "Dosage",
    operator: "Opérateur",
    equipment_page: "Équipements",
    logistics: "Machines & maintenance",
    hours: "Heures",
    fuel: "Carburant",
    next_maintenance: "Prochaine maintenance",
    equip_opérationnel: "Opérationnel",
    equip_maintenance: "Maintenance",
    equip_hors_service: "Hors service",
    employees_page: "Équipes",
    daily_rate: "Taux journalier",
    skills: "Compétences",
    per_day: "jour",
    invoice: "Facture",
    quote: "Devis",
    delivery_note: "Bon de livraison",
    price_tiers: "Prix dégressifs",
    from_qty: "dès",
    recurrence: "Récurrence",
    aucune: "Aucune",
    hebdomadaire: "Hebdomadaire",
    mensuelle: "Mensuelle",
    discover: "Découvrir",
    discover_badge: "Plateforme digitale d'agrobusiness & d'aquaculture",
    discover_title: "De la terre et de l'eau à la table, pilotez votre croissance.",
    discover_sub: "Agriculture, pisciculture, marketplace, supply chain, finance et intelligence — une seule plateforme pensée pour l'Afrique.",
    discover_features: "Ce que fait AgriNova",
    discover_cta_title: "Prêt à cultiver autrement ?",
    discover_cta_sub: "Commandez nos productions fraîches ou rejoignez la plateforme.",
    guest_banner: "Mode invité — accès limité aux pages de présentation. Connectez-vous pour tout débloquer.",
    explore_guest: "Explorer en invité",
    feat_agri_title: "Agriculture",
    feat_agri_desc: "Parcelles, cultures, travaux, rendements prévus vs réels.",
    feat_pisci_title: "Pisciculture",
    feat_pisci_desc: "Bassins, espèces, alimentation, FCR, qualité de l'eau.",
    feat_stock_title: "Stocks",
    feat_stock_desc: "Intrants, seuils d'alerte, historique des achats.",
    feat_market_title: "Marketplace",
    feat_market_desc: "Commande en ligne, prix dégressifs, suivi en temps réel.",
    feat_logi_title: "Logistique",
    feat_logi_desc: "Pipeline de livraison de la commande à la remise.",
    feat_pay_title: "Paiements",
    feat_pay_desc: "Orange Money, MTN Mobile Money, virement, cash.",
    feat_analytics_title: "Pilotage",
    feat_analytics_desc: "Cockpit KPIs, analytics, rentabilité par activité.",
    feat_ai_title: "Assistant IA",
    feat_ai_desc: "Posez vos questions, l'IA analyse vos données d'exploitation.",
    feat_weather_title: "Météo",
    feat_weather_desc: "Prévisions locales et recommandations agricoles.",
    feat_qr_title: "Traçabilité",
    feat_qr_desc: "QR codes sur les commandes, du bassin au client.",
    feat_roles_title: "Rôles & sécurité",
    feat_roles_desc: "Accès par rôle : admin, gérant, comptable, ouvrier, invité.",
    licenses: "Licences",
    franchise_model: "Modèle de franchise",
    generate_license: "Générer une licence",
    license_key: "Clé de licence",
    business_model: "Modèle d'activité",
    payment_status: "Paiement",
    expires_at: "Expiration",
    franchisee_name: "Franchisé",
    plan: "Plan",
    month: "mois",
    copied: "Copié !",
    lic_active: "Active",
    "lic_activée": "Activée",
    "lic_suspendue": "Suspendue",
    "lic_expirée": "Expirée",
    "payée": "Payée",
    role_visiteur: "Visiteur",
    role_desc_visiteur: "Lecture seule des modules de base",
    pricing: "Tarifs & Licences",
    popular: "Populaire",
    per_month: "/mois",
    users_included: "utilisateurs inclus",
    modules_included: "Modules inclus",
    contact_us: "Nous contacter",
    mod_agriculture: "Agriculture",
    mod_pisciculture: "Pisciculture",
    mod_apiculture: "Apiculture",
    mod_stocks: "Stocks & fournisseurs",
    mod_marketplace: "Marketplace",
    mod_paiements: "Paiements Mobile Money",
    mod_meteo: "Météo & alertes",
    mod_analytics: "Analytics",
    mod_assistant_ia: "Assistant IA",
    mod_transformation: "Transformation",
    mod_equipements: "Équipements",
    mod_rh: "RH & équipes",
    mod_multi_entites: "Multi-entités",
    follow_us: "Suivez-nous",
    website: "Site web",
    contact_title: "Nous contacter",
    contact_sub: "Une question, un projet de licence ou de franchise ? Écrivez-nous, nous répondons vite.",
    message: "Message",
    send: "Envoyer",
    message_sent: "Message envoyé ! Nous vous répondrons rapidement.",
    ai_usage: "Usage IA",
    ai_usage_sub: "Consommation réelle de l'assistant par modèle (tokens relevés à chaque réponse).",
    requests: "Requêtes",
    ai_cost_standard: "Coût standard",
    ai_cost_high: "Coût élevé — analyses complexes",
    ai_cost_low: "Coût réduit — rapide",
    ai_balance_hint: "Crédits débités sur la clé universelle — solde géré dans Profil → Gérer le plan → Universal Key.",
    google_login: "Continuer avec Google",
    or_separator: "ou",
    forgot_password: "Mot de passe oublié ?",
    send_reset_link: "Envoyer le lien",
    reset_email_sent: "Si ce compte existe, un email de réinitialisation vient d'être envoyé.",
    reset_password_title: "Nouveau mot de passe",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    passwords_mismatch: "Les mots de passe ne correspondent pas",
    password_updated: "Mot de passe mis à jour — vous pouvez vous connecter.",
    invalid_reset_link: "Lien invalide — refaites une demande de réinitialisation.",
    back_to_login: "Retour à la connexion",
    ask_question: "Posez votre question…",
    ai_assistant: "Assistant IA",
    ai_sub: "Posez vos questions — l'assistant connaît vos données d'exploitation.",
    ai_welcome: "Bonjour ! Je suis l'assistant AgriNova. Interrogez-moi sur vos bassins, parcelles, stocks, commandes ou paiements.",
    ai_empty: "Posez votre première question à l'assistant AgriNova.",
    ai_action_task: "Nouvelle tâche",
    ai_action_feeding: "Alimentation bassin",
    ai_prefilled: "Formulaire pré-rempli par l'assistant — vérifiez puis enregistrez.",
    ai_action_done: "Alimentation enregistrée pour le bassin.",
    ai_action_pond_not_found: "Bassin introuvable — vérifiez la référence.",
    ai_action_supplier: "Nouveau fournisseur",
    ai_action_customer: "Nouveau client",
    ai_action_invoice: "Facture PDF",
    ai_action_confirm: "Confirmer l'enregistrement",
    ai_action_saved: "Enregistré ✓",
    ai_action_purchase: "Commande fournisseur",
    ai_action_health: "Traitement santé",
    ai_action_reminder: "Relance client (email)",
    ai_action_complete: "Marquer terminé",
    ai_action_measure: "Relevé bassin (correction)",
    ai_dictate: "Dicter ma question",
    ai_transcribing: "Transcription en cours…",
    ai_listen: "Écouter",
    ai_mic_error: "Micro inaccessible — vérifiez l'autorisation du navigateur.",
    ai_voice_continuous: "Mode voix continu (mains libres) — dicter, la réponse est lue, puis je réécoute",
    ai_action_order_not_found: "Commande introuvable — vérifiez la référence.",
    ai_placeholder: "Votre question…",
    weather: "Météo",
    humidity: "humidité",
    tomorrow: "demain",
    analytics_page: "Analytics",
    revenue_monthly: "CA mensuel",
    sales_by_product: "Ventes par produit",
    mortality_by_pond: "Mortalité par bassin",
    cost_by_task: "Coûts par type de travaux",
    transformation: "Transformation",
    batches: "lots",
    batch: "Lot",
    input_qty: "Quantité entrée",
    output_qty: "Quantité sortie",
    losses: "Pertes",
    production_date: "Date production",
    qr_code: "QR traçabilité",
    settings: "Paramètres",
    settings_sub: "Intégrations externes — activation automatique dès l'enregistrement",
    twilio_sub: "Alertes SMS & WhatsApp automatiques (stock bas, récoltes, mortalité…)",
    twilio_active: "Actif",
    twilio_inactive: "Non configuré",
    twilio_phone: "Numéro Twilio (From)",
    alert_phone: "Numéro de réception des alertes",
    twilio_test: "Envoyer un SMS test",
    twilio_hint: "Identifiants disponibles sur console.twilio.com. Stockés de façon sécurisée en base, jamais réaffichés.",
    export_excel: "Exporter Excel",
    default_site: "Site par défaut",
    create_account: "Créer un compte",
    register_sub: "Votre compte démarre en mode invité — l'administrateur vous donnera accès aux modules.",
    account_created: "Compte créé ! L'administrateur validera votre accès.",
    no_account_yet: "Pas encore de compte ? Créer un compte",
    have_account: "Déjà un compte ? Se connecter",
  },
  en: {
    app_name: "AgriNova",
    slogan: "Feed · Grow · Innovate",
    login: "Sign in",
    logout: "Sign out",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    dashboard: "Dashboard",
    parcelles: "Plots",
    pisciculture: "Aquaculture",
    suppliers: "Suppliers & Stock",
    clients: "Customers & Orders",
    payments: "Payments",
    hectares: "Total hectares",
    ongoing_crops: "Ongoing crops",
    pending_orders: "Pending orders",
    quarter_revenue: "Quarter revenue",
    low_stock: "Low stock",
    upcoming_harvests: "Upcoming harvests",
    recent_orders: "Recent orders",
    recent_payments: "Recent payments",
    revenue_by_method: "Revenue by method",
    add: "Add",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    name: "Name",
    category: "Category",
    site: "Site",
    area: "Area (ha)",
    culture: "Crop",
    status: "Status",
    actions: "Actions",
    map_view: "Map view",
    grid_view: "Grid view",
    list_view: "List",
    all_sites: "All sites",
    ponds: "Ponds",
    species: "Species",
    capacity: "Capacity (m³)",
    stocked_date: "Stocking date",
    current_stock: "Current stock",
    quantity: "Quantity",
    unit: "Unit",
    threshold: "Min threshold",
    unit_cost: "Unit cost",
    supplier: "Supplier",
    phone: "Phone",
    city: "City",
    customer: "Customer",
    type: "Type",
    product: "Product",
    price: "Price",
    total: "Total",
    destination: "Destination",
    order_date: "Order date",
    method: "Method",
    amount: "Amount",
    reference: "Reference",
    date: "Date",
    orange_money: "Orange Money",
    mtn_mobile_money: "MTN Mobile Money",
    virement: "Bank transfer",
    cash: "Cash",
    welcome: "Welcome",
    days: "days",
    no_data: "No data",
    confirm_delete: "Confirm deletion?",
    added: "Added",
    updated: "Updated",
    deleted: "Deleted",
    error: "Error",
    farm_sites: "Farm sites",
    seeded_date: "Sown date",
    expected_harvest: "Expected harvest",
    plantings: "Sowings",
    harvests: "Harvests",
    new_planting: "New sowing",
    new_harvest: "New harvest",
    stock_items: "Inputs",
    orders: "Orders",
    deliveries: "Deliveries",
    manage: "Manage",
    parcelle: "Plot",
    scientific_name: "Scientific name",
    cycle_days: "Cycle (days)",
    en_attente: "Pending",
    livrée: "Delivered",
    role_admin: "Administrator",
    key_indicators: "Key indicators",
    active_ponds: "Active ponds",
    total_customers: "Registered customers",
    total_suppliers: "Suppliers",
    harvest_timeline: "Harvest calendar",
    drag_hint: "Drag and drop a harvest to another month to reschedule it",
    drop_here: "Drop here",
    notifications: "Notifications",
    mark_all_read: "Mark all read",
    pdf_report: "Quarterly PDF report",
    quarter: "Quarter",
    year: "Year",
    download: "Download",
    hero_title: "From land and water to the table, drive your growth.",
    hero_sub: "Crops, aquaculture, suppliers, stock, customers & Mobile Money payments — your farm, simplified.",
    dark_mode: "Dark mode",
    light_mode: "Light mode",
    install_app: "Install AgriNova",
    install_hint: "Quick access from your home screen, even offline",
    install: "Install",
    users: "Users",
    role: "Role",
    add_user: "New user",
    role_admin: "Administrator",
    role_gerant: "Manager",
    role_comptable: "Accountant",
    role_ouvrier: "Field worker",
    role_desc_admin: "Full access, user management",
    role_desc_gerant: "Daily operations, no user management",
    role_desc_comptable: "Read-only + orders & payments",
    role_desc_ouvrier: "Field: pond logs & harvests",
    pond_journal: "Journal",
    add_log: "New entry",
    weight_g: "Avg weight (g)",
    feed_kg: "Feed (kg)",
    mortality: "Mortality",
    water_temp: "Water temp (°C)",
    latest_weight: "Current weight",
    total_feed: "Total feed",
    purchases: "Purchases",
    total_spent: "Total spent",
    agri_kpis: "Agriculture",
    pisci_kpis: "Aquaculture",
    business_kpis: "Business",
    alerts_title: "Alerts",
    active_plots: "Active plots",
    cultures_maturing: "Maturing ≤ 30 d",
    production_harvested: "Harvested prod.",
    fish_alive: "Fish in production",
    biomass_kg: "Est. biomass",
    avg_fcr: "Avg FCR",
    feed_30d: "Feed 30 d",
    mortality_30d: "Mortality 30 d",
    orders_total: "Orders",
    sales_today: "Today's sales",
    receivables: "Receivables",
    out_of_stock: "Out of stock",
    oxygen: "Oxygen (mg/L)",
    commandée: "Ordered",
    confirmée: "Confirmed",
    préparée: "Prepared",
    expédiée: "Shipped",
    en_livraison: "Out for delivery",
    annulée: "Cancelled",
    marketplace: "Marketplace",
    order_now: "Place an order",
    portal_sub: "Order our produce directly — real-time tracking",
    your_order: "Your order",
    order_success: "Order registered!",
    keep_ref: "Keep your tracking reference:",
    track_order: "Track my order",
    track: "Track",
    tasks: "Field operations",
    assignee: "Assignee",
    equipment: "Equipment",
    cost: "Cost",
    planifiée: "Planned",
    en_cours: "In progress",
    terminée: "Done",
    task_labour: "Ploughing",
    task_préparation_sol: "Soil preparation",
    task_semis: "Sowing",
    task_désherbage: "Weeding",
    task_fertilisation: "Fertilization",
    task_traitement: "Treatment",
    task_irrigation: "Irrigation",
    task_récolte: "Harvest",
    task_entretien: "Maintenance",
    rentability: "Profitability",
    expected_cost: "Expected cost",
    actual_cost: "Actual cost",
    cost_gap: "Cost gap",
    expected_yield: "Expected yield (t)",
    actual_yield: "Actual yield (t)",
    yield_gap: "Yield gap",
    feed_cost: "Feed cost",
    production: "Production",
    revenue: "Revenue",
    margin: "Margin",
    en_cours_label: "Ongoing",
    récoltée: "Harvested",
    health: "Health & Biosecurity",
    biosecurity: "Prevention & treatments",
    agriculture: "Agriculture",
    health_maladie: "Disease",
    health_ravageur: "Pest",
    health_traitement: "Treatment",
    health_incident: "Incident",
    health_quarantaine: "Quarantine",
    target: "Target",
    issue: "Description",
    product_used: "Product / Action",
    dosage: "Dosage",
    operator: "Operator",
    equipment_page: "Equipment",
    logistics: "Machines & maintenance",
    hours: "Hours",
    fuel: "Fuel",
    next_maintenance: "Next maintenance",
    equip_opérationnel: "Operational",
    equip_maintenance: "Maintenance",
    equip_hors_service: "Out of service",
    employees_page: "Teams",
    daily_rate: "Daily rate",
    skills: "Skills",
    per_day: "day",
    invoice: "Invoice",
    quote: "Quote",
    delivery_note: "Delivery note",
    price_tiers: "Volume pricing",
    from_qty: "from",
    recurrence: "Recurrence",
    aucune: "None",
    hebdomadaire: "Weekly",
    mensuelle: "Monthly",
    discover: "Discover",
    discover_badge: "Digital agribusiness & aquaculture platform",
    discover_title: "From land and water to the table, drive your growth.",
    discover_sub: "Agriculture, aquaculture, marketplace, supply chain, finance and intelligence — one platform built for Africa.",
    discover_features: "What AgriNova does",
    discover_cta_title: "Ready to grow differently?",
    discover_cta_sub: "Order our fresh produce or join the platform.",
    guest_banner: "Guest mode — limited to presentation pages. Sign in to unlock everything.",
    explore_guest: "Explore as guest",
    feat_agri_title: "Agriculture",
    feat_agri_desc: "Plots, crops, field operations, expected vs actual yields.",
    feat_pisci_title: "Aquaculture",
    feat_pisci_desc: "Ponds, species, feeding, FCR, water quality.",
    feat_stock_title: "Stock",
    feat_stock_desc: "Inputs, alert thresholds, purchase history.",
    feat_market_title: "Marketplace",
    feat_market_desc: "Online ordering, volume pricing, real-time tracking.",
    feat_logi_title: "Logistics",
    feat_logi_desc: "Delivery pipeline from order to handover.",
    feat_pay_title: "Payments",
    feat_pay_desc: "Orange Money, MTN Mobile Money, bank transfer, cash.",
    feat_analytics_title: "Steering",
    feat_analytics_desc: "KPI cockpit, analytics, per-activity profitability.",
    feat_ai_title: "AI Assistant",
    feat_ai_desc: "Ask questions — the AI analyzes your farm data.",
    feat_weather_title: "Weather",
    feat_weather_desc: "Local forecasts and farming recommendations.",
    feat_qr_title: "Traceability",
    feat_qr_desc: "QR codes on orders, from pond to customer.",
    feat_roles_title: "Roles & security",
    feat_roles_desc: "Role-based access: admin, manager, accountant, worker, guest.",
    licenses: "Licenses",
    franchise_model: "Franchise model",
    generate_license: "Generate a license",
    license_key: "License key",
    business_model: "Business model",
    payment_status: "Payment",
    expires_at: "Expiry",
    franchisee_name: "Franchisee",
    plan: "Plan",
    month: "month",
    copied: "Copied!",
    lic_active: "Active",
    "lic_activée": "Activated",
    "lic_suspendue": "Suspended",
    "lic_expirée": "Expired",
    "payée": "Paid",
    role_visiteur: "Visitor",
    role_desc_visiteur: "Read-only access to basic modules",
    pricing: "Pricing & Licenses",
    popular: "Popular",
    per_month: "/month",
    users_included: "users included",
    modules_included: "Included modules",
    contact_us: "Contact us",
    mod_agriculture: "Agriculture",
    mod_pisciculture: "Aquaculture",
    mod_apiculture: "Beekeeping",
    mod_stocks: "Stock & suppliers",
    mod_marketplace: "Marketplace",
    mod_paiements: "Mobile Money payments",
    mod_meteo: "Weather & alerts",
    mod_analytics: "Analytics",
    mod_assistant_ia: "AI Assistant",
    mod_transformation: "Processing",
    mod_equipements: "Equipment",
    mod_rh: "HR & teams",
    mod_multi_entites: "Multi-entity",
    follow_us: "Follow us",
    website: "Website",
    contact_title: "Contact us",
    contact_sub: "A question, a license or franchise project? Write to us, we reply fast.",
    message: "Message",
    send: "Send",
    message_sent: "Message sent! We'll get back to you shortly.",
    ai_usage: "AI usage",
    ai_usage_sub: "Actual assistant consumption per model (tokens recorded on each response).",
    requests: "Requests",
    ai_cost_standard: "Standard cost",
    ai_cost_high: "High cost — complex analyses",
    ai_cost_low: "Low cost — fast",
    ai_balance_hint: "Credits are drawn from the universal key — balance managed in Profile → Manage plan → Universal Key.",
    google_login: "Continue with Google",
    or_separator: "or",
    forgot_password: "Forgot password?",
    send_reset_link: "Send reset link",
    reset_email_sent: "If this account exists, a reset email has just been sent.",
    reset_password_title: "New password",
    new_password: "New password",
    confirm_password: "Confirm password",
    passwords_mismatch: "Passwords do not match",
    password_updated: "Password updated — you can now sign in.",
    invalid_reset_link: "Invalid link — please request a new reset.",
    back_to_login: "Back to sign in",
    ask_question: "Ask your question…",
    ai_assistant: "AI Assistant",
    ai_sub: "Ask anything — the assistant knows your farm data.",
    ai_welcome: "Hello! I'm the AgriNova assistant. Ask me about your ponds, plots, stock, orders or payments.",
    ai_empty: "Ask the AgriNova assistant your first question.",
    ai_action_task: "New task",
    ai_action_feeding: "Pond feeding",
    ai_prefilled: "Form pre-filled by the assistant — review then save.",
    ai_action_done: "Feeding logged for the pond.",
    ai_action_pond_not_found: "Pond not found — check the reference.",
    ai_action_supplier: "New supplier",
    ai_action_customer: "New customer",
    ai_action_invoice: "PDF invoice",
    ai_action_confirm: "Confirm & save",
    ai_action_saved: "Saved ✓",
    ai_action_purchase: "Supplier purchase",
    ai_action_health: "Health treatment",
    ai_action_reminder: "Customer reminder (email)",
    ai_action_complete: "Mark as done",
    ai_action_measure: "Pond measurement (correction)",
    ai_dictate: "Dictate my question",
    ai_transcribing: "Transcribing…",
    ai_listen: "Listen",
    ai_mic_error: "Mic unavailable — check browser permission.",
    ai_voice_continuous: "Continuous voice mode (hands-free) — dictate, the reply is read aloud, then I listen again",
    ai_action_order_not_found: "Order not found — check the reference.",
    ai_placeholder: "Your question…",
    weather: "Weather",
    humidity: "humidity",
    tomorrow: "tomorrow",
    analytics_page: "Analytics",
    revenue_monthly: "Monthly revenue",
    sales_by_product: "Sales by product",
    mortality_by_pond: "Mortality by pond",
    cost_by_task: "Costs by operation type",
    transformation: "Processing",
    batches: "batches",
    batch: "Batch",
    input_qty: "Input qty",
    output_qty: "Output qty",
    losses: "Losses",
    production_date: "Production date",
    qr_code: "QR traceability",
    settings: "Settings",
    settings_sub: "External integrations — auto-activated on save",
    twilio_sub: "Automatic SMS & WhatsApp alerts (low stock, harvests, mortality…)",
    twilio_active: "Active",
    twilio_inactive: "Not configured",
    twilio_phone: "Twilio number (From)",
    alert_phone: "Alert recipient number",
    twilio_test: "Send test SMS",
    twilio_hint: "Credentials available at console.twilio.com. Stored securely in database, never displayed.",
    export_excel: "Export Excel",
    default_site: "Default site",
    create_account: "Create an account",
    register_sub: "Your account starts in guest mode — the administrator will grant you module access.",
    account_created: "Account created! The administrator will validate your access.",
    no_account_yet: "No account yet? Create one",
    have_account: "Already have an account? Sign in",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("agrinova_lang") || "fr");
  useEffect(() => { localStorage.setItem("agrinova_lang", lang); }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || k;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
export const useI18n = () => useContext(I18nCtx);
